import { Badge, Card } from '@personachat/ui';
import { ExternalLink } from 'lucide-react';

import type { NavEntry } from '../layout/navigation';
import { LEGACY_ADMIN_URL } from '../lib/env';

import { PageHeader } from './PageHeader';

/** Écran pas encore construit : ce qu'il fera, dans quel lot, et où travailler d'ici là. */
export function UpcomingPage({ entry }: { entry: NavEntry }) {
  const Icone = entry.icon;
  return (
    <>
      <PageHeader title={entry.label} lead={entry.summary} />
      <Card className="upcoming">
        <div className="upcoming__icon" aria-hidden="true">
          <Icone size={22} />
        </div>
        <div className="upcoming__body">
          <div className="upcoming__meta">
            <Badge tone="gold">Lot {entry.lot}</Badge>
            <span>Cahier des charges, section {entry.section}</span>
          </div>
          <p>Cet écran arrive avec le lot {entry.lot}. D’ici là, l’ancien back-office reste disponible pour ces opérations.</p>
          <a className="ui-btn ui-btn--secondary" href={LEGACY_ADMIN_URL} target="_blank" rel="noreferrer">
            <ExternalLink size={15} aria-hidden="true" />
            Ouvrir l’ancien back-office
          </a>
        </div>
      </Card>
    </>
  );
}
